// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.audio-container {
    /* display: inline-block;
    position: relative; */
    /* width: 100%;
    height: 100%; */
    /* text-align: center;
    justify-content: center; */
  }
  .order-num_heading,
.quantity_heading {
    font-size: 12px;
    color: var(--light-grey-color) !important;
  }
  .order-num_number{
    color: var(--dark-grey-color);
    font-weight: 400;
  }
  .total-amount_heading {
    font-size: 12px;
    color: var(--light-black-text) !important;
  }
  .total-amount_number {
    color: var(--black-text);
    font-weight: 500;
  }
  .section-heading {
    color: black !important;
    margin-bottom: 1em;
  }
  .left-section-container-lines {
    margin: 0.3rem 0;
    color: var(--line-color) !important;
  }
  .notes_height{
    --bs-gutter-x: 0 !important;
    height:max-content  !important;
  }
.noPreview {
    /* position: absolute; */
    top: 0;
    left: 0;
    width: 250px;
    height: 250px;
    background-color: #F6F6F6; /* Example background color */
    /* text-align: center; */
    justify-content: center;
    display: flex;
    align-items: center;
    color: #555; /* Example text color */
    font-size: 16px; /* Example font size */
  }
.noPreview2 {
    /* position: absolute; */
    top: 0;
    left: 0;
    width: 60%;
    height: 100%;
    background-color: #F6F6F6; /* Example background color */
    /* text-align: center; */
    justify-content: center;
    display: flex;
    align-items: center;
    text-align: center;
    color: #555; /* Example text color */
    font-size: 16px; /* Example font size */
  }
  .input_btn{
    background-color: transparent;
    border: none;
    padding-left: 7px;
    cursor: pointer;
  }
  .input_icon{
    height: 16px;
    width: 16px;
  }`, "",{"version":3,"sources":["webpack://./src/Pages/Notes/notes.css"],"names":[],"mappings":"AAAA;IACI;yBACqB;IACrB;mBACe;IACf;8BAC0B;EAC5B;EACA;;IAEE,eAAe;IACf,yCAAyC;EAC3C;EACA;IACE,6BAA6B;IAC7B,gBAAgB;EAClB;EACA;IACE,eAAe;IACf,yCAAyC;EAC3C;EACA;IACE,wBAAwB;IACxB,gBAAgB;EAClB;EACA;IACE,uBAAuB;IACvB,kBAAkB;EACpB;EACA;IACE,gBAAgB;IAChB,mCAAmC;EACrC;EACA;IACE,2BAA2B;IAC3B,8BAA8B;EAChC;AACF;IACI,wBAAwB;IACxB,MAAM;IACN,OAAO;IACP,YAAY;IACZ,aAAa;IACb,yBAAyB,EAAE,6BAA6B;IACxD,wBAAwB;IACxB,uBAAuB;IACvB,aAAa;IACb,mBAAmB;IACnB,WAAW,EAAE,uBAAuB;IACpC,eAAe,EAAE,sBAAsB;EACzC;AACF;IACI,wBAAwB;IACxB,MAAM;IACN,OAAO;IACP,UAAU;IACV,YAAY;IACZ,yBAAyB,EAAE,6BAA6B;IACxD,wBAAwB;IACxB,uBAAuB;IACvB,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,WAAW,EAAE,uBAAuB;IACpC,eAAe,EAAE,sBAAsB;EACzC;EACA;IACE,6BAA6B;IAC7B,YAAY;IACZ,iBAAiB;IACjB,eAAe;EACjB;EACA;IACE,YAAY;IACZ,WAAW;EACb","sourcesContent":[".audio-container {\n    /* display: inline-block;\n    position: relative; */\n    /* width: 100%;\n    height: 100%; */\n    /* text-align: center;\n    justify-content: center; */\n  }\n  .order-num_heading,\n.quantity_heading {\n    font-size: 12px;\n    color: var(--light-grey-color) !important;\n  }\n  .order-num_number{\n    color: var(--dark-grey-color);\n    font-weight: 400;\n  }\n  .total-amount_heading {\n    font-size: 12px;\n    color: var(--light-black-text) !important;\n  }\n  .total-amount_number {\n    color: var(--black-text);\n    font-weight: 500;\n  }\n  .section-heading {\n    color: black !important;\n    margin-bottom: 1em;\n  }\n  .left-section-container-lines {\n    margin: 0.3rem 0;\n    color: var(--line-color) !important;\n  }\n  .notes_height{\n    --bs-gutter-x: 0 !important;\n    height:max-content  !important;\n  }\n.noPreview {\n    /* position: absolute; */\n    top: 0;\n    left: 0;\n    width: 250px;\n    height: 250px;\n    background-color: #F6F6F6; /* Example background color */\n    /* text-align: center; */\n    justify-content: center;\n    display: flex;\n    align-items: center;\n    color: #555; /* Example text color */\n    font-size: 16px; /* Example font size */\n  }\n.noPreview2 {\n    /* position: absolute; */\n    top: 0;\n    left: 0;\n    width: 60%;\n    height: 100%;\n    background-color: #F6F6F6; /* Example background color */\n    /* text-align: center; */\n    justify-content: center;\n    display: flex;\n    align-items: center;\n    text-align: center;\n    color: #555; /* Example text color */\n    font-size: 16px; /* Example font size */\n  }\n  .input_btn{\n    background-color: transparent;\n    border: none;\n    padding-left: 7px;\n    cursor: pointer;\n  }\n  .input_icon{\n    height: 16px;\n    width: 16px;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
